import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import isEmpty from 'lodash/isEmpty';
import snakeCase from 'lodash/snakeCase';
import { useSelector } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// HELPERS
import { useReport } from '../helpers/getReportData';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// LOCAL COMPONENTS
import EmailForm from './EmailForm';

// MAIN COMPONENT
const EmailSidebar = () => {

  // HOOKS
  const { reportID, report_title, filters } = useReport();

  // REACT REDUX
  const lookups = useSelector(({ lookups }) => lookups)
  const { reports : { dateFilterOption } = {} } = useSelector((state) => state.preferences);

  // INITIAL VALUES
  const findDefault = useCallback(
    (lookup, defaultCode) => {
      if (isEmpty(lookups?.[lookup])) return undefined;
      return lookups[lookup].reduce((acc, cur) => cur[`${snakeCase(lookup)}_code`] === defaultCode ? cur[`${snakeCase(lookup)}_id`] : acc, undefined)
    },
    [lookups]
  )
  const initialValues = useMemo(
    () => ({
      report_id: reportID,
      day_of_week: '',
      day_of_month: '',
      email_subject: report_title,
      email_body: '',
      is_active: 1,
      is_for_wholesale: filters?.saleType === 'R' ? '0' : filters?.saleType === 'W' ? '1' : '',
      new_used: filters?.newUsed === '1' ? '1' : filters?.newUsed === '0' ? '2' : '',
      report_email_attachment_type_id: findDefault('reportEmailAttachmentType', 'PDF'),
      report_email_frequency_id: findDefault('reportEmailFrequency', 'once'),
      report_email_daterange_id: findDefault('reportEmailDaterange', String(dateFilterOption).toLowerCase()) || findDefault('reportEmailDaterange', 'mtd'),
    }),
    [reportID, report_title, findDefault, filters, dateFilterOption]
  )

  // RENDER
  return (
    <Sidebar
      name="emailReport"
      title="Email Report"
    >
      <EmailForm
        as={Sidebar.Form}
        endpoint={ENDPOINTS.dashboard.report.email(reportID)}
        initialValues={initialValues}
      />
    </Sidebar>
  );  
}

// CHILD COMPONENTS
const EmailSidebarButton = props => (
  <Sidebar.Button
    name="emailReport"
    label="Email Report"
    icon={{
      use: 'email',
      order: 1
    }}
    size="sm"
    outline
    {...props}
  />
)
EmailSidebar.Button = EmailSidebarButton;

// EXPORT
export default EmailSidebar;
